export const SERVICES = [
  {
    n: "01",
    slug: "software-development",
    cta: "Discuss a build",
    icon: "product" as const,
    t: "Software Development",
    h: "Software built around how you work",
    d: "Web applications, customer portals and internal systems designed around your processes, so your team stops working around its tools.",
    items: [
      "Web Applications",
      "Customer Portals",
      "Dashboards",
      "Internal Systems",
      "Booking & Ordering Platforms",
      "API Development",
      "System Integrations",
    ],
    idealFor: "Teams that have outgrown spreadsheets and off-the-shelf tools",
    timeline: "8 to 16 weeks",
  },
  {
    n: "02",
    slug: "ai-automation",
    cta: "Automate something",
    icon: "tech" as const,
    t: "AI & Automation",
    h: "Hand the repetitive work to software",
    d: "We find the manual, repeated tasks in your operation and automate them, so your people spend their hours on work that needs judgement.",
    items: [
      "Workflow Automation",
      "AI Assistants & Agents",
      "Document & Data Processing",
      "Customer Support Automation",
      "Reporting Pipelines",
      "Tool & CRM Integrations",
      "Process Audits",
    ],
    idealFor: "Businesses losing hours every week to manual work",
    timeline: "4 to 12 weeks",
  },
  {
    n: "03",
    slug: "websites-brand",
    cta: "Start a brand project",
    icon: "website" as const,
    t: "Websites & Brand",
    h: "Be understood in five seconds",
    d: "Positioning, identity and a fast website that make it obvious what you do, who it's for and why you're worth paying.",
    items: [
      "Brand Strategy",
      "Positioning & Naming",
      "Logo & Identity",
      "Visual Systems",
      "Corporate Websites",
      "Landing Pages",
      "E-commerce",
    ],
    idealFor: "Businesses launching, rebranding or being underestimated",
    timeline: "3 to 8 weeks",
  },
  {
    n: "04",
    slug: "support-growth",
    cta: "Ask about support",
    icon: "growth" as const,
    t: "Support & Growth",
    h: "Launch is where the real work starts",
    d: "Software keeps its value when someone looks after it. We monitor, maintain and keep improving what we've built with you.",
    items: [
      "Maintenance & Monitoring",
      "Performance Optimisation",
      "Security Updates",
      "Feature Development",
      "Analytics & Reporting",
      "SEO Support",
      "Technical Advisory",
    ],
    idealFor: "Businesses that want a long-term technology partner",
    timeline: "Monthly retainer",
  },
]

export const PROCESS = [
  {
    n: "01",
    t: "Discover",
    d: "We learn how your business runs, who your customers are and what's getting in the way.",
    tag: "We ask before we assume.",
  },
  {
    n: "02",
    t: "Define",
    d: "We turn what we've learned into a clear plan: scope, priorities, timeline and cost.",
    tag: "No surprises later.",
  },
  {
    n: "03",
    t: "Design",
    d: "We design the interface, the system and the experience around that plan.",
    tag: "Every decision has a reason.",
  },
  {
    n: "04",
    t: "Build",
    d: "Our engineers build and test the approved design in short cycles you can follow.",
    tag: "You see progress as it happens.",
  },
  {
    n: "05",
    t: "Launch",
    d: "We test on real devices, fix what needs fixing and prepare everything for release.",
    tag: "Finished means finished.",
  },
  {
    n: "06",
    t: "Grow",
    d: "After launch we stay on to improve, automate and build whatever the business needs next.",
    tag: "Launch isn't the finish line.",
  },
]

/* ----------------------------------------------------------------------------
   The studio in numbers.

   Shared by the homepage's short "who we are" block and the About page's
   numbers band, so the two can never drift apart — a visitor who reads "50+
   projects" on one page and a different figure on the other stops believing
   either.
---------------------------------------------------------------------------- */
export const STUDIO_STATS = [
  { n: "50+", l: "Projects delivered" },
  { n: "20+", l: "Businesses supported" },
  { n: "10+", l: "Industries served" },
  { n: "5+", l: "Years building software" },
] as const
